export enum WorkSubmissionID {
    ICE = "ICES",
    ISWC = "ISWC",
    CisNet = "CisNet",
    CisNet2 = "CisNet2",
    WID = "WID",
    WIDACK = "WIDACK"
}
